import { useEffect } from 'react';

/**
 * Hook for listening to the Maskito reject event on an input element. Triggers the provided
 * callback when the event is fired.
 *
 * @param callback - Callback to be called when the input is rejected.
 * @param ref - A ref to the underlying input element.
 */ function useOnReject(callback, ref) {
    useEffect(()=>{
        const handleMaskitoReject = ()=>{
            ref.current && callback?.(ref.current.value);
        };
        ref.current?.addEventListener('maskitoReject', handleMaskitoReject);
        return ()=>ref.current?.removeEventListener('maskitoReject', handleMaskitoReject);
    }, [
        callback
    ]);
}

export { useOnReject };
//# sourceMappingURL=use-on-reject.js.map
